import React from 'react';
import { NavigationReducer, NavigationReducerDataFilterTags } from '../../../Redux/Reducers/NavigationReducer';
import { useAppDispatch, useAppSelector } from '../../../Redux/Store/hooks';
import { ItemTypeConstants } from '../../../Resources/ItemTypeConstants';
import { CollectionFilter } from '../../Data/CollectionFilter';
import { ICollectionToShow } from '../../Data/CollectionToShow';
import { StaticTableComponent } from '../Components/Specific/StaticTableComponent';
import { FilterController } from '../Controllers/FilterController';

type CollectionViewParameters = {
  filters : CollectionFilter[],
  filterSelection : NavigationReducerDataFilterTags[] | undefined,
  collections : ICollectionToShow[],
  setFilterSelection : (newFilterSelection: NavigationReducerDataFilterTags[]) => void,
};

export function CollectionView({
  filters,
  filterSelection,
  collections,
  setFilterSelection,
} : CollectionViewParameters) {

  // Grab the dispatch hook from Redux
  const dispatch = useAppDispatch();

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  // Grab the action to change active page
  const { changeState } = NavigationReducer.actions;

  // Callback to change the active page
  const showNewPage = (collectionName : string, objectName : string, pageType : string) => {
    dispatch(
      changeState({
        page: pageType,
        collection: collectionName,
        object: objectName,
        filter: undefined,
        searchQuery: undefined,
      }),
    );
  };

  const renderCollection = (
    collection : ICollectionToShow,
    index : number,
  ) : JSX.Element => {

    if (collection.objects.length > 0) {
      return (
        <StaticTableComponent
          title={collection.name}
          itemsList={collection.objects}
          itemsType={ItemTypeConstants.DYNAMIC_ITEMS}
          displayNewPage={showNewPage}
          noContentText={strings.NO_CONTENT_TEXT}
          key={index}
        />
      );
    }

    return (<div className="empty" />);
  };

  return (
    <div className="container-fluid" style={{ height: '100%' }}>
      <div className="row items-presentation-layout">
        { filters.length > 0 ? (
          <>
            <div className="col col-lg-9 col-md-9 col-sm-12 col-xs-12">
              {collections
                && collections.map((collection, index) => renderCollection(collection, index))}
            </div>
            <div className="col col-lg-2 col-md-3 col-sm-12 col-xs-12">
              <FilterController
                filters={filters}
                filterSelection={filterSelection}
                setFilterSelection={setFilterSelection}
              />
            </div>
          </>
        ) : (
          <div className="col-12">
            {collections
            && collections.map((collection, index) => renderCollection(collection, index))}
          </div>
        )}
      </div>
    </div>
  );
}
